export default "__VITE_ASSET__Cl7pCS5V__"